<ng-container *ngIf="card$ | async as memberCard; else loadingRef">
  <!-- Member Info -->
  <div
    class="barcode-member-info d-flex align-items-center"
    [ngClass]="
      centerMemberInfo
        ? 'justify-content-center text-center'
        : 'justify-content-between'
    "
    *ngIf="memberDetails$ | async as memberDetails"
  >
    <div class="text-white">
      <p class="barcode-member-name mb-0">
        {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
      </p>
      <p class="barcode-member-subtitle mb-0">
        {{ memberCard.ProductCodeDisplayName }} -
        {{ memberCard.ExternalRefNumber }}
      </p>
    </div>
    <a
      *ngIf="!centerMemberInfo"
      class="barcode-rewards-btn d-flex align-items-center gap-2"
      [routerLink]="'/rewards/wallet'"
    >
      <span class="material-symbols-outlined" aria-hidden="true"
        >qr_code_scanner</span
      >
      <span>{{ "nav.rewards" | translate : { fgbdefault: "Rewards" } }}</span>
    </a>
  </div>

  <!-- QR Card -->
  <div class="barcode-card">
    <p class="barcode-title mb-0">{{ "barcode.title" | translate }}</p>

    <ng-container *ngIf="barcode$ | async as barcode; else barcodeLoading">
      <fgb-rotating-barcode
        [barcode]="barcode.Barcode"
        [phrase]="barcode.Phrase"
      ></fgb-rotating-barcode>
    </ng-container>
    <ng-template #barcodeLoading>
      <fgbcl-loading [color]="'black'"></fgbcl-loading>
    </ng-template>

    <p class="barcode-description mb-0">
      {{ "barcode.description" | translate }}
    </p>

    <!-- Discounts -->
    <div class="barcode-discounts w-100">
      <div
        *ngIf="ecash$ | async as ecash"
        class="barcode-discount-row d-flex justify-content-between align-items-center"
      >
        <span class="barcode-discount-label">{{
          "member.card.reward.credit" | translate
        }}</span>
        <span class="barcode-discount-value">{{
          ecash | FortressCurrencyPipe
        }}</span>
      </div>
      <div
        *ngIf="memberCard.DiscountLevel"
        class="barcode-discount-row d-flex justify-content-between align-items-center"
      >
        <span class="barcode-discount-label">{{
          "member.card.concession.discount" | translate
        }}</span>
        <span class="barcode-discount-value"
          >{{ memberCard.DiscountLevel }}%</span
        >
      </div>
      <div
        *ngIf="memberCard.RetailDiscountLevel"
        class="barcode-discount-row d-flex justify-content-between align-items-center"
      >
        <span class="barcode-discount-label">{{
          "member.card.team.shop.discount" | translate
        }}</span>
        <span class="barcode-discount-value"
          >{{ memberCard.RetailDiscountLevel }}%</span
        >
      </div>
    </div>

    <!-- Seating Info -->
    <button
      *ngIf="showSeating && (hasTickets$ | async)"
      class="barcode-wallet-btn w-100 d-flex align-items-center justify-content-center gap-2"
      (click)="openTicketsModal()"
    >
      <span class="material-symbols-outlined" aria-hidden="true"
        >mobile_ticket</span
      >
      <span>{{ "barcode.seating.information" | translate }}</span>
    </button>
  </div>

  <!-- Payment Button -->
  <div class="barcode-payment-wrapper">
    <fgb-payment-button></fgb-payment-button>
  </div>

  <!-- Fold -->
  <div class="barcode-fold"></div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>

<!-- Tickets Modal -->
<ng-template #ticketsModal let-modal>
  <div class="tickets-modal-content">
    <!-- Header -->
    <div
      class="tickets-modal-header d-flex justify-content-between align-items-center"
    >
      <p class="tickets-modal-title mb-0">
        {{ "barcode.my.tickets" | translate : { fgbdefault: "My Tickets" } }}
        ({{ tickets.length }})
      </p>
      <button
        class="tickets-close-btn"
        (click)="modal.dismiss()"
        aria-label="Close"
      >
        <span class="material-symbols-outlined text-info" aria-hidden="true"
          >close</span
        >
      </button>
    </div>

    <hr class="tickets-divider" />

    <!-- Content -->
    <div class="tickets-modal-body">
      <!-- Event Info -->
      <ng-container *ngIf="tickets.length > 0">
        <div
          class="tickets-event d-flex justify-content-between align-items-center mb-3"
        >
          <div>
            <p class="tickets-event-name mb-1">{{ tickets[0].Title }}</p>
            <p class="tickets-event-date mb-0">
              {{ tickets[0].ValidDate | date : "EEE, MMM d  hh:mma" }}
            </p>
          </div>
          <img
            *ngIf="tickets[0].AwayTeamImage"
            class="tickets-away-team-logo"
            [src]="tickets[0].AwayTeamImage"
            alt=""
          />
        </div>

        <!-- Ticket Cards -->
        <div class="d-flex flex-column gap-3">
          <div class="ticket-card" *ngFor="let ticket of tickets">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="ticket-field">
                <p class="ticket-label mb-0">
                  {{
                    "barcode.ticket.section"
                      | translate : { fgbdefault: "Section" }
                  }}
                </p>
                <p class="ticket-value mb-0">{{ ticket.Area }}</p>
              </div>
              <div class="d-flex gap-4">
                <div class="ticket-field">
                  <p class="ticket-label mb-0">
                    {{
                      "barcode.ticket.row" | translate : { fgbdefault: "Row" }
                    }}
                  </p>
                  <p class="ticket-value mb-0">{{ ticket.Row }}</p>
                </div>
                <div class="ticket-field">
                  <p class="ticket-label mb-0">
                    {{
                      "barcode.ticket.seat" | translate : { fgbdefault: "Seat" }
                    }}
                  </p>
                  <p class="ticket-value mb-0">{{ ticket.Seat }}</p>
                </div>
              </div>
            </div>
            <p class="ticket-product-code mb-0">
              {{ ticket.PriceCodeDescription }}
            </p>
          </div>
        </div>
      </ng-container>

      <p *ngIf="tickets.length === 0" class="tickets-empty text-center">
        {{
          "barcode.no.tickets"
            | translate : { fgbdefault: "No upcoming tickets found." }
        }}
      </p>
    </div>

    <hr class="tickets-divider" />

    <!-- Actions -->
    <div class="tickets-modal-actions">
      <button class="tickets-cancel-btn" (click)="modal.dismiss()">
        {{ "barcode.ticket.cancel" | translate : { fgbdefault: "Cancel" } }}
      </button>
    </div>
  </div>
</ng-template>
